/**
 * Checks if v matches the ByteOffset interface
 * @param v
 */
export function isByteOffset(v) {
    if (typeof v !== "object")
        return false;
    if (v === null)
        return false;
    if (typeof v.byteOffset !== "number")
        return false;
    if (typeof v.componentType !== "undefined" && typeof v.componentType !== "string")
        return false;
    return true;
}
